module.exports = {
  EntityComponentSystem: require("./entity-component-system"),
  EntityPool: require("./entity-pool")
};



//////////////////
// WEBPACK FOOTER
// ./~/entity-component-system/lib/index.js
// module id = 2
// module chunks = 0